//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import service from '@/utils/request'
import api from '@/utils/api'

export default {
  name: 'Activation',
  data () {
    return {
      code: '',
      loading: false,
      result: null,
      inputFocus: false
    }
  },
  methods: {
    onCodeInput (e) {
      let val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '')
      if (val.startsWith('WZ')) {
        val = val.substring(2)
      }
      const parts = []
      for (let i = 0; i < val.length && parts.length < 3; i += 4) {
        parts.push(val.substring(i, i + 4))
      }
      this.code = parts.length ? 'WZ-' + parts.join('-') : ''
    },
    normalizeCodeForSubmit (code) {
      let val = code.toUpperCase().replace(/[^A-Z0-9]/g, '')
      if (val.startsWith('WZ')) {
        val = val.substring(2)
      }
      if (val.length !== 12) {
        return code.trim().toUpperCase()
      }
      return 'WZ-' + val.substring(0, 4) + '-' + val.substring(4, 8) + '-' + val.substring(8, 12)
    },
    goBack () {
      // 显式回我的词书，避免 WeChat history 拦截导致无法返回
      const from = this.$route.query.from
      if (from === 'mine') {
        this.$router.push({ path: '/mine', query: { hideTrans: 'true' } })
        return
      }
      this.$router.push({ path: '/myBooks', query: { hideTrans: 'true' } })
    },
    goStudy () {
      this.$router.push({ path: '/wordIndex?hideTrans=true' })
    },
    handleRedeem () {
      const trimmed = this.code.trim()
      if (!trimmed) {
        this.$vux.toast.text('请输入激活码')
        return
      }
      this.loading = true
      this.result = null
      const payload = { code: this.normalizeCodeForSubmit(trimmed) }
      service.post(api.activationRedeem, payload).then(res => {
        this.result = res
        this.$vux.toast.text(res.message || '激活成功')
        this.code = ''
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/publicView/me/activation.vue